import SelectPageView from './SelectPageView';

export default SelectPageView;